module.exports = __webpack_public_path__ + "img/builder-post-locked.c8ef12e7.svg";